// SignoutDetails.js
import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../Navbar/Navbar';
import axios from 'axios';
import QRCode from 'qrcode.react';
import SignatureCanvas from 'react-signature-canvas';
import './SignoutDetails.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const apiUrl = "/api";

function SignoutDetails() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const tenantId = parseInt(localStorage.getItem('selectedTenant')) || 1;
  const [selectedEquipmentType, setSelectedEquipmentType] = useState('');
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [signoutDetails, setSignoutDetails] = useState({});
  const [signoutTotalDetails, setSignoutTotalDetails] = useState([]);
  const [notes, setNotes] = useState('');
  const [qrId, setQrId] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const printRef = useRef();
  const sigCanvas = useRef({});
  const [approvalStatus, setApprovalStatus] = useState('');
  const [approvedBy, setApprovedBy] = useState('');
  const [approvedAt, setApprovedAt] = useState('');
  const [agentSignature, setAgentSignature] = useState('');
  const [signedAt, setSignedAt] = useState('');
  const [supervisorName, setSupervisorName] = useState('');


  useEffect(() => {

    if (!localStorage.getItem('token')) {
      // Redirect to login page if not logged in 
      window.location.href = '#/login';
      window.location.reload();
      return null;
    }

    const userRole = localStorage.getItem('userRole');
    setIsAdmin(userRole === 'admin');

    // Make an API call to fetch signout details using Axios
    const token = localStorage.getItem('token');
    axios.get(apiUrl + `/inv/signout/?id=${id}&tenant_id=${tenantId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(response => {
        console.log('Signout Details:', response.data);  // Assuming the API returns an array
        if (response.data && response.data.length > 0) {
          setSignoutDetails(response.data[0]);
          setNotes(response.data[0].notes || '');
          setSignoutDetails(response.data[0]);
          setNotes(response.data[0].notes || '');
          setApprovalStatus(response.data[0].approval_status);
          setApprovedBy(response.data[0].approved_by);
          setApprovedAt(response.data[0].approved_at);
          setAgentSignature(response.data[0].agent_signature);
          setSignedAt(response.data[0].signed_at);
          setSupervisorName(response.data[0].supervisor_name);
          setSignoutTotalDetails(response.data);
        } else {
          // No signout found for this ID and tenant
          setSignoutDetails(null);
          setNotes('');
          setSignoutTotalDetails([]);
        }
      })
      .catch(error => console.error('Error fetching signout details:', error));
  }, [id]);

  const handleUpdateNotes = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(apiUrl + '/saveNotes', {
        id: signoutDetails.id,
        tenant_id: tenantId,
        notes: notes,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Handle the response as needed
      console.log('Notes updated successfully:', response.data);
    } catch (error) {
      // Handle errors
      console.error('Error updating notes:', error);
    }
  };
  const getEquipmentName = (itemId) => {
    switch (itemId) {
      case 100001:
        return 'Mouse';
      case 100002:
        return 'Keyboard';
      case 100003:
        return 'Ethernet Cable';
      case 100004:
        return 'USB A-B Cable';
      case 100005:
        return 'USB Headset';
      case 100006:
        return 'VGA Cable / Display Cable';
      case 100007:
        return 'DVI Cable / Display Cable';
      case 100008:
        return 'Power Cable';
      case 100009:
        return 'Monitor';
      case 100010:
        return 'DisplayPort Cable';
      case 100011:
        return "PC's Power Cable";
      default:
        return null;
    }
  };
  const handleCloseSignout = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(apiUrl + '/close-signout-sheet', {
        id: signoutDetails.id,
        tenant_id: tenantId,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.reload()
      // Handle the response as needed
      //console.log('Signout closed successfully:', response.data);

      // You can also perform additional actions here, such as updating the UI or redirecting the user
    } catch (error) {
      // Handle errors
      console.error('Error closing signout:', error);
    }
  };

  const handleApproveSignout = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(apiUrl + '/signout/approve', {
        id: signoutDetails.id,
        tenant_id: tenantId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.reload();
    } catch (error) {
      console.error('Error approving signout:', error);
      alert('Failed to approve signout');
    }
  };

  const handleSaveSignature = async () => {
    if (sigCanvas.current.isEmpty()) {
      alert('Please sign before saving');
      return;
    }

    const signatureData = sigCanvas.current.getTrimmedCanvas().toDataURL('image/png');

    try {
      const token = localStorage.getItem('token');
      await axios.post(apiUrl + '/save-signature', {
        id: signoutDetails.id,
        signature: signatureData,
        tenant_id: tenantId
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.reload();
      //setAgentSignature(signatureData);
      //setSignedAt(new Date().toISOString());
    } catch (error) {
      console.error('Error saving signature:', error);
      alert('Failed to save signature');
    }
  };

  const handleClearSignature = () => {
    sigCanvas.current.clear();
  };
  const handleRequestApproval = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(apiUrl + '/signout/request-approval', {
        id: signoutDetails.id,
        tenant_id: tenantId,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.reload();
    } catch (error) {
      console.error('Error requesting approval:', error);
      alert('Error requesting approval: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleApprove = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(apiUrl + '/signout/approve', {
        id: signoutDetails.id,
        tenant_id: tenantId,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.reload();
    } catch (error) {
      console.error('Error approving signout:', error);
      alert('Error approving signout: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleReject = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(apiUrl + '/signout/reject', {
        id: signoutDetails.id,
        tenant_id: tenantId,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      window.location.reload();
    } catch (error) {
      console.error('Error rejecting signout:', error);
      alert('Error rejecting signout: ' + (error.response?.data?.error || error.message));
    }
  };
  const handleAddItem = async () => {
    //console.log(selectedEquipmentType + "and "+id);
    try {
      // Make an API call to add the selected item to the signout sheet
      const token = localStorage.getItem('token');
      const response = await axios.post(apiUrl + '/submit-new-item', {
        id: signoutDetails.id,
        tenant_id: tenantId,  // Assuming you have the signout sheet ID
        itemid: selectedEquipmentType,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Handle the response as needed
      console.log('Item added successfully:', response.data);
    } catch (error) {
      // Handle errors
      console.error('Error adding item:', error);
    }


  };
  const handleAddItemWithQrId = async () => {

    console.log("Qrid of the device:" + qrId + " , Sheet qrid: " + id);
    try {
      // Make an API call to add the selected item to the signout sheet
      const token = localStorage.getItem('token');
      const response = await axios.get(apiUrl + `/inv/${qrId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Handle the response as needed
      console.log('Item retrieved successfully:', response.data[0]);

      if (response.data[0]) {
        const response2 = await axios.post(apiUrl + '/submit-new-item', {
          id: id,  // Assuming you have the signout sheet ID
          itemid: response.data[0].id,
          tenant_id: tenantId,
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        // Handle the response as needed
        console.log('Item added successfully:', response2.data);

      }
    } catch (error) {
      // Handle errors
      console.error('Error adding item:', error);
    }

  };
  const getEquipmentId = (equipmentName) => {
    switch (equipmentName) {
      case 'Mouse':
        return 100001;
      case 'Keyboard':
        return 100002;
      case 'Ethernet Cable':
        return 100003;
      case 'USB A-B Cable':
        return 100004;
      case 'USB Headset':
        return 100005;
      case 'VGA Cable / Display Cable':
        return 100006;
      case 'DVI Cable / Display Cable':
        return 100007;
      case 'Power Cable':
        return 100008;
      case 'Monitor':
        return 100009;
      case 'DisplayPort Cable':
        return 100010;
      case "PC's Power Cable":
        return 100011;
      default:
        return null; // Return null for unknown equipment
    }
  };
  const getEquipmentOptions = () => {
    const equipmentOptions = [
      { id: 100000, name: ' ' },
      { id: 100001, name: 'Mouse' },
      { id: 100002, name: 'Keyboard' },
      { id: 100003, name: 'Ethernet Cable' },
      { id: 100004, name: 'USB A-B Cable' },
      { id: 100005, name: 'USB Headset' },
      { id: 100006, name: 'VGA Cable / Display Cable' },
      { id: 100007, name: 'DVI Cable / Display Cable' },
      { id: 100008, name: 'Power Cable' },
      { id: 100009, name: 'Monitor' },
      { id: 100010, name: 'DisplayPort Cable' },
      { id: 100011, name: "PC's Power Cable" },
    ];

    return equipmentOptions;
  };
  const handleRemoveItem = async (equipment) => {
    try {
      console.log(equipment);
      if (signoutDetails.locked) {
        // If the signout sheet is locked, mark the item as returned
        const token = localStorage.getItem('token');
        await axios.post(apiUrl + '/mark-item-returned', {
          id: equipment.SignDetailsId,
          tenant_id: tenantId,
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (equipment.Type === "Computer" || equipment.Type === "Laptop"
          || equipment.Type === "COMPUTER" || equipment.Type === "LAPTOP" || equipment.Type === "ROUTER" || equipment.Type === "Router"
          || equipment.Type === "Monitor" || equipment.Type === "Monitor") {

          equipment.Location = "HAM INV";
          const token = localStorage.getItem('token');
          const datasent = await axios.post(apiUrl + '/update-item-location', { ...equipment, tenant_id: tenantId }, {
            headers: { Authorization: `Bearer ${token}` }
          })
          console.log('Item updated successfully:', datasent);

        }

      } else if (!signoutDetails.locked) {
        // If the signout sheet is not locked and user is admin, remove the item
        const token = localStorage.getItem('token');
        await axios.post(apiUrl + '/remove-new-item', {
          id: equipment.SignDetailsId,
          tenant_id: tenantId,
        }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (equipment.Type === "Computer" || equipment.Type === "Laptop"
          || equipment.Type === "COMPUTER" || equipment.Type === "LAPTOP" || equipment.Type === "ROUTER" || equipment.Type === "Router"
          || equipment.Type === "Monitor" || equipment.Type === "Monitor") {

          equipment.Location = "HAM INV";


          //console.log('Item Locationupdated successfully:',equipment );
          const token = localStorage.getItem('token');
          const datasent = await axios.post(apiUrl + '/update-item-location', { ...equipment, tenant_id: tenantId }, {
            headers: { Authorization: `Bearer ${token}` }
          })
          console.log('updated result:', datasent);
        }


        // Update the equipment list after removing the item
        //setEquipmentList(prevList => prevList.filter(item => item.id !== itemId));
      }

      // You can reload the page or update the data as needed
      window.location.reload(); // Reload the page to reflect changes

    } catch (error) {
      // Handle errors
      console.error('Error handling item:', error);
    }
  };

  const printToPdf = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(22);
    doc.text("Sign-out Sheet", 14, 22);

    // Agent Details
    doc.setFontSize(12);
    doc.text(`Agent Name: ${signoutDetails.name}`, 14, 40);
    doc.text(`Tenant: ${signoutDetails.tenant_name}`, 14, 48);
    doc.text(`Signout Sheet No: ${signoutDetails.id}`, 14, 56);

    // QR Code
    const qrCodeCanvas = document.querySelector('canvas');
    if (qrCodeCanvas) {
      const qrCodeDataUri = qrCodeCanvas.toDataURL('image/png');
      doc.addImage(qrCodeDataUri, 'PNG', 150, 15, 45, 45);
    }

    // Notes
    doc.setFontSize(12);
    doc.text("Notes:", 14, 70);
    doc.setFontSize(10);
    doc.text(notes, 14, 78, { maxWidth: 180 });

    // Equipment List
    const tableColumn = ["Equipment Type", "QR ID", "Model", "Serial", "Returned"];
    const tableRows = [];

    signoutTotalDetails.forEach(item => {
      const rowData = [
        item.Type ? item.Type : getEquipmentName(item.itemid),
        item.qrid,
        item.Model,
        item.Serial,
        item.returndate && item.returndate !== '0000-00-00 00:00:00' ? new Date(item.returndate).toLocaleDateString() : 'No'
      ];
      tableRows.push(rowData);
    });

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 100,
    });

    // Signature Section
    let finalY = doc.lastAutoTable.finalY || 120;
    finalY += 10;

    // If digitally signed, show that
    if (agentSignature) {
      doc.text("Digitally Signed by Agent:", 14, finalY);
      finalY += 5;
      doc.addImage(agentSignature, 'PNG', 14, finalY, 60, 30);
      finalY += 35;
      doc.text(`Date: ${new Date(signedAt).toLocaleString()}`, 14, finalY);
      finalY += 10;

      if (approvalStatus === 'Approved') {
        doc.text(`Approved by Supervisor: ${supervisorName || 'Admin'} on ${new Date(approvedAt).toLocaleDateString()}`, 14, finalY);
      }
    } else {
      // Fallback to manual lines
      doc.setFontSize(12);
      doc.text("Preceding Equipment Received By:", 14, finalY);
      finalY += 10;

      autoTable(doc, {
        body: [
          ["Tech:", "____________________", "Signature:", "____________________", "Date:", "____________________"],
          ["Staff Member:", signoutDetails.name, "Signature:", "____________________", "Date:", "____________________"],
        ],
        startY: finalY,
        theme: 'plain',
        styles: { fontSize: 10 },
      });
    }

    doc.save(`signout-sheet-${id}.pdf`);
  };

  if (!signoutDetails) {
    return (
      <div>
        <Navigation />
        <Container className="mt-5">
          <Row>
            <Col>
              <div className="text-center">
                <h3>Signout Not Found</h3>
                <p>The requested signout could not be found or you don't have permission to view it.</p>
                <a href="#/" className="btn btn-primary">Return to Home</a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }

  return (
    <div ref={printRef}>
      <Navigation />
      {/* Print timestamp - only visible when printing */}
      <div
        className="print-timestamp"
        data-timestamp={new Date().toLocaleString()}
        style={{ display: 'none' }}
      />

      {/* === HEADER SECTION: Agent Info + Status + Actions === */}
      <div className="signout-details-container">
        <div className="signout-details-content">
          {/* Left: Agent Info & Notes */}
          <Col sm={7}>
            <div className="agent-details">
              <h3>Agent Name: {signoutDetails.name} ({signoutDetails.tenant_name})</h3>
              <p className="text-muted mb-0">Signout Sheet #{signoutDetails.id}</p>
            </div>
            <div className="notes-section mt-3">
              <h6 className="fw-bold mb-2">Notes:</h6>
              <div className="d-flex gap-2 align-items-end">
                <textarea
                  className="notes-textarea flex-grow-1"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="Enter notes..."
                  rows={3}
                />
                <Button variant="primary" onClick={handleUpdateNotes} size="sm">
                  Update
                </Button>
              </div>
            </div>
          </Col>

          {/* Right: Status, QR Code, Primary Actions */}
          <Col sm={5} className="d-flex flex-column align-items-end">
            <div className="d-flex align-items-center gap-3 mb-3">
              {/* Status Badge - Show clear workflow state */}
              <div className={`badge fs-6 py-2 px-3 ${signoutDetails.locked === 1 ? 'bg-dark' :
                signoutDetails.approval_status === 'Approved' ? 'bg-success' :
                  signoutDetails.approval_status === 'Requested' ? 'bg-warning text-dark' :
                    signoutDetails.approval_status === 'Rejected' ? 'bg-danger' : 'bg-secondary'
                }`}>
                {signoutDetails.locked === 1
                  ? 'Ready for Shipment'
                  : signoutDetails.approval_status === 'Approved'
                    ? '✓ Approved (Ready to Close)'
                    : signoutDetails.approval_status === 'Requested'
                      ? '⏳ Awaiting Approval'
                      : signoutDetails.approval_status === 'Rejected'
                        ? '✗ Rejected'
                        : 'Draft'
                }
              </div>

              {/* Primary Actions - Top Right */}
              <div className="d-flex gap-2">
                {signoutDetails.locked === 0 && (
                  <>
                    {signoutDetails.approval_status === 'Approved' ? (
                      <Button variant="success" onClick={handleCloseSignout} size="sm">
                        Close
                      </Button>
                    ) : signoutDetails.approval_status === 'Requested' ? (
                      isAdmin ? (
                        <>
                          <Button variant="success" size="sm" onClick={handleApprove}>✓ Approve</Button>
                          <Button variant="outline-danger" size="sm" onClick={handleReject}>✗ Reject</Button>
                        </>
                      ) : (
                        <Button variant="secondary" size="sm" disabled>
                          ⏳ Awaiting Supervisor
                        </Button>
                      )
                    ) : (
                      <Button variant="warning" size="sm" onClick={handleRequestApproval}>
                        {signoutDetails.approval_status === 'Rejected' ? '🔄 Re-Request Approval' : '📤 Request Approval'}
                      </Button>
                    )}
                  </>
                )}
                <Button variant="outline-primary" size="sm" onClick={printToPdf}>
                  📄 Print PDF
                </Button>
              </div>
            </div>

            {/* QR Code */}
            <div className="text-center">
              <QRCode value={window.location.href} size={100} />
            </div>

            {signoutDetails.approval_status === 'Approved' && signoutDetails.approved_at && (
              <small className="text-muted mt-2">
                Approved by Supervisor on {new Date(signoutDetails.approved_at).toLocaleDateString()}
              </small>
            )}
          </Col>
        </div>
      </div>

      {/* === ADD EQUIPMENT SECTION (Only when unlocked) === */}
      {signoutDetails.locked === 0 && (
        <div className="add-equipment-section">
          <h5 className="section-title mb-3">➕ Add Equipment</h5>
          <Row className="align-items-end g-3">
            {/* Method 1: By QR-ID */}
            <Col md={5}>
              <div className="add-method-card">
                <label className="form-label fw-bold text-muted small">Add by QR-ID</label>
                <div className="d-flex gap-2">
                  <input
                    type="text"
                    className="form-control"
                    value={qrId}
                    onChange={(e) => setQrId(e.target.value)}
                    placeholder="Enter QR-ID (e.g., 10001)"
                  />
                  <Button variant="success" onClick={handleAddItemWithQrId}>
                    Add
                  </Button>
                </div>
              </div>
            </Col>

            <Col md={1} className="text-center">
              <span className="text-muted fw-bold">OR</span>
            </Col>

            {/* Method 2: By Equipment Type */}
            <Col md={6}>
              <div className="add-method-card">
                <label className="form-label fw-bold text-muted small">Add by Equipment Type (Consumables)</label>
                <div className="d-flex gap-2">
                  <select
                    className="form-select"
                    onChange={(e) => setSelectedEquipmentType(getEquipmentId(e.target.value))}
                  >
                    {getEquipmentOptions().map((option) => (
                      <option key={option.id} value={option.name}>
                        {option.name}
                      </option>
                    ))}
                  </select>
                  <Button variant="success" onClick={handleAddItem}>
                    Add
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}

      {/* === EQUIPMENT LIST TABLE === */}
      <div className="equipment-list">
        <h5 className="section-title mb-3">📦 Equipment List ({signoutTotalDetails.length} items)</h5>
        <table className="table table-bordered table-hover mb-0">
          <thead>
            <tr>
              <th style={{ width: '35%' }}>Equipment Type</th>
              <th style={{ width: '15%' }} className="text-center">QR ID</th>
              <th style={{ width: '20%' }} className="text-center">Model</th>
              <th style={{ width: '15%' }} className="text-center">Serial</th>
              <th style={{ width: '15%' }} className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {signoutTotalDetails.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-muted py-4">
                  No equipment added yet. Use the section above to add items.
                </td>
              </tr>
            ) : (
              signoutTotalDetails.map(equipment => (
                <tr key={equipment.SignDetailsId || equipment.id}>
                  <td className="fw-medium">
                    {equipment.Type ? equipment.Type : getEquipmentName(equipment.itemid)}
                  </td>
                  <td className="text-center text-muted">{equipment.qrid || '-'}</td>
                  <td className="text-center">{equipment.Model || '-'}</td>
                  <td className="text-center">{equipment.Serial || '-'}</td>
                  <td className="text-center">
                    {(equipment.returndate === '0000-00-00 00:00:00' || equipment.returndate === null) ? (
                      <button
                        className="custom-remove-button"
                        onClick={() => handleRemoveItem(equipment)}
                      >
                        {signoutDetails.locked ? 'Return' : 'Remove'}
                      </button>
                    ) : (
                      <span className="returndate-set-message">
                        ✓ Returned {new Date(equipment.returndate).toLocaleDateString()}
                      </span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* === LOCKED STATE: Signature Section === */}
      {signoutDetails.locked === 1 && (
        <div className="locked-details">
          <div className="preceding-equipment">
            <h5>Preceding Equipment Received By:</h5>
            <Table className="preceding-equipment-table table-bordered table-hover table-sm">
              <tbody>
                <tr>
                  <td>Tech:</td>
                  <td>____________________</td>
                  <td>Signature:</td>
                  <td>____________________</td>
                  <td>Date:</td>
                  <td>____________________</td>
                </tr>
                <tr>
                  <td>Staff Member:</td>
                  <td>{signoutDetails.name}</td>
                  <td>Signature:</td>
                  <td>____________________</td>
                  <td>Date:</td>
                  <td>____________________</td>
                </tr>
              </tbody>
            </Table>
          </div>
          <p className="text-muted mt-3">
            If any issues arise with the equipment setup, please email our IT Dept at <strong>ITDept@dependableit.com</strong>
          </p>
        </div>
      )}
    </div>
  );
}

export default SignoutDetails;